<script>
	export let img;
	import { scale, fade } from 'svelte/transition';
	import { quintOut } from 'svelte/easing';
</script>

<div transition:fade="{{delay: 250, duration: 1000}}" class="loader">
	<img 
		transition:scale="{{
			duration: 300, 
			delay: 300, 
			opacity: 0.5, 
			start: 0, 
			easing: quintOut
		}}" 
		width="70" 
		height="70" 
		alt="Indicateur de chargement" 
		src="{img}" />
</div>

<style>
	.loader {
		position: fixed;
		z-index: 2;
		left: 0;
		top: 42px;
		right: 0;
		bottom: 0;
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-bottom: 42px;
	}
</style>